import axios from "axios"
import type { GeneralResultVO } from "@/api"
import { API_TOKEN, URL_REDIRECT, API_REGISTER, API_RUOYI, TokenKey } from "@/constants/config"
import cookies from "@/util/cookies"

async function wraper(fn: any) {
  try {
    const result = await fn
    return result.data
  } catch (e: any) {
    return { code: 999999, msg: e.message }
  }
}

interface LoginArgs {
  // 手机号
  username: string
  // 登录方式type(string 1-密码登录；2-验证码登录)
  type: string
  // 密码
  password?: string
  // 验证码
  code?: string
}

interface LoginResult {
  code: number
  msg: string
  data: {
    access_token: string
    expires_in: number
    user_name: string
    systemConfigAuth: boolean
  }
}

//登录接口 + 短信验证码登陆
export const login = async (data: LoginArgs) => {
  return await wraper(axios.post<LoginResult>(API_RUOYI + `/auth/login`, data))
}

interface SmsArgs {
  phone: string
  // 1-注册，2-登录，3-重置密码
  operation: number
}

// 获取短信验证码
export const getSms = async (data: SmsArgs) => {
  return await wraper(axios.post<GeneralResultVO>(API_RUOYI + `/auth/sms/send`, data))
}

interface ResetPasswordArgs {
  phone: string
  password: string
  code: string
}

// 重设密码
export const resetPassword = async (data: ResetPasswordArgs) => {
  return await wraper(axios.post<GeneralResultVO>(API_RUOYI + `/auth/resetPwd`, data))
}

interface RegisterArgs {
  // 昵称
  nickName: string
  phone: string
  password: string
  code: string
}

// 注册
export const register = async (data: RegisterArgs) => {
  return await wraper(axios.post<GeneralResultVO>(API_RUOYI + `/auth/register`, data))
}

// 获取token
export const getToken = async (code: any) => {
  return await wraper(
    axios.get(API_TOKEN + `/oauth/get_token`, {
      params: {
        code,
        redirectUri: encodeURIComponent(URL_REDIRECT),
      },
    }),
  )
}

// 登出
export const signout = async () => {
  const user = cookies.parsedCookies()
  return await wraper(
    axios.delete(API_RUOYI + `/auth/logout`, {
      headers: {
        Authorization: user[TokenKey],
      },
    }),
  )
}

// 获取图形校验码
export const getCaptcha = async () => {
  return await wraper(axios.get(API_REGISTER + `/v1/captcha`))
}

// 获取密码错误次数
export const getCaptchaTime = async (type: string, phone: any) => {
  return await wraper(
    axios.get(API_REGISTER + `/v1/captcha/time?codevalue=${type}&&phone=${phone}`),
  )
}
